import React, { useContext } from 'react';

import Loading from 'components/Loading';
import ScorecardContainer from 'components/Scorecard';

import ChartPlaceholder from './ChartPlaceholder';
import { useKpiListScorecard } from './kpiList';
import LegacyGadgetBody from './LegacyGadgetBody';
import StudioContentTypeContext from './StudioContentTypeContext';

// A KPI list Table: the KPI List it shows, drawn as the classic Scorecard
// card draws it, over the block's periods. As a block it has the card's own
// title, menu and tasks footer; as a Composite element, just its KPIs under
// the element's header. On a dashboard or report (isOnView) the periods
// follow the view's DashboardContext, as the classic card's do; Studio has
// none, so there they follow what Studio is editing.
const StudioKpiList = ({
  content,
  isInteractive,
  isElement = false,
  isOnView = false,
}: {
  content: Studio.ChartContent;
  isInteractive: boolean;
  isElement?: boolean;
  isOnView?: boolean;
}) => {
  const contentType = useContext(StudioContentTypeContext);
  const { scorecard, isLoading } = useKpiListScorecard(content);
  const kpiList = content.table?.kpiList;

  if (!kpiList?.scorecardId) {
    return (
      <ChartPlaceholder
        cardId={content.id}
        visType="table"
        message="Choose a KPI list"
      />
    );
  }
  if (!scorecard) {
    // One just created shows once it's loaded
    return isLoading ? (
      <Loading />
    ) : (
      <ChartPlaceholder
        cardId={content.id}
        visType="table"
        message="KPI list not found"
      />
    );
  }
  return (
    <LegacyGadgetBody
      $isInteractive={isInteractive}
      data-testid={`studio-card-kpi-list-${content.id}`}
    >
      <div>
        <ScorecardContainer
          scorecard={scorecard}
          isAddKpiEnabled={false}
          numberOfPeriods={kpiList.numberOfPeriods}
          contentType={isOnView ? undefined : contentType}
          isHeaderless={isElement}
        />
      </div>
    </LegacyGadgetBody>
  );
};

export default StudioKpiList;
